import { WidgetProps } from '@rjsf/utils';
import ListSelect, { ListOption } from './ListSelect';
import ListSelectAutocomplete from './ListSelectAutocomplete';

type SchemaOption = {
  const: string | null;
  title: string;
};

type ListSelectionOptions<T> = {
  options: ListOption<T>[];
  autocomplete?: boolean;
  render?: (value: T) => React.ReactNode;
};

function ListSelectionWidget<T>(props: WidgetProps) {
  const { schema, required, disabled, readonly } = props;
  const widgetOptions = props.options as ListSelectionOptions<T> | undefined;

  const options =
    widgetOptions?.options ??
    (
      (schema.anyOf as SchemaOption[]) ??
      (schema.oneOf as SchemaOption[]) ??
      props.options?.enumOptions?.map((option) => ({
        const: option.value,
        title: option.label,
      }))
    )
      .filter((option) => option.const)
      .map(
        (option) =>
          ({
            const: option.const,
            value: option.title,
          }) as ListOption<T>,
      );

  const ListSelectComponent = widgetOptions?.autocomplete ? ListSelectAutocomplete : ListSelect;

  return (
    <ListSelectComponent
      options={options}
      value={props.value}
      onChange={props.onChange}
      label={schema.title}
      required={required}
      disabled={disabled || readonly}
      render={widgetOptions?.render}
    />
  );
}
export default ListSelectionWidget;
